import type { JobAdCandidacyStatus } from "@/modules/jobAdDetail/types"

export const JOB_AD_DETAIL_ROUTE_PREFIX = "job-offers"
export const JOB_AD_DETAIL_ROUTE_SLUG = "jobAdSlug"

export const JOB_AD_DETAIL_QUERY_KEY = "job-ad-detail"

export const GET_COMPANY_INFO_ENDPOINT =
  "/jobteaser.company.services.company_page.v1alpha1/CompanyPageService/GetCompanyInfoForJobDetail"
export const JOB_AD_COMPANY_INFO_QUERY_KEY = "job-ad-company-info-for-job-detail-endpoint"

export const GET_COMPANY_CARD_ENDPOINT = "/jobteaser.company.card.v1alpha1/CardService/GetCard"
export const JOB_AD_COMPANY_CARD_QUERY_KEY = "job-ad-company-card"

export const GET_CANDIDACY_STATUS_ENDPOINT = "/jobteaser.candidate.v1alpha1/CandidateService/GetCandidacyStatus"

export const SIMILAR_JOB_ADS_QUERY_KEY = "similar-job-ads"

export const QUERY_CACHE_TIME = 30 * 60 * 1000 // 30 min
export const QUERY_STALE_TIME = 15 * 60 * 1000 // 15 min

export const ASIDE_TO_TOP_DISTANCE_DEBOUNCE_DELAY = 50

export const JOB_AD_STATUS = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  INACTIVE: "INACTIVE",
  PENDING: "PENDING",
} as const

export const CANDIDACY_STATUS = {
  CANDIDACY_STATUS_APPLIED: "CANDIDACY_STATUS_APPLIED",
  CANDIDACY_STATUS_NOT_APPLIED: "CANDIDACY_STATUS_NOT_APPLIED",
  CANDIDACY_STATUS_SHORTLISTED: "CANDIDACY_STATUS_SHORTLISTED",
  CANDIDACY_STATUS_SHORTLISTED_ACCEPTED: "CANDIDACY_STATUS_SHORTLISTED_ACCEPTED",
  CANDIDACY_STATUS_SHORTLISTED_DECLINED: "CANDIDACY_STATUS_SHORTLISTED_DECLINED",
} as const

export const DOM_REF_IDS = {
  ACTIONS_BOTTOM: "job-ad-detail-action-bottom",
  ACTIONS_STICKY: "job-ad-detail-action-sticky",
  ACTIONS_TOP: "job-ad-detail-action-top",
  CONTENT: "job-ad-detail-content",
}

export const SHORTLIST_STATUSES = {
  OFFER_ACCEPTED: "OFFER_ACCEPTED",
  OFFER_REJECTED: "OFFER_REJECTED",
}

export const DEFAULT_CANDIDACY: JobAdCandidacyStatus = {
  shortlistId: "",
  status: "CANDIDACY_STATUS_NOT_APPLIED",
}

export const LOCAL_STORAGE_APPLIED_EXTERNAL_JOB_ADS = "applied_external_job_ads"
